import { combineReducers } from 'redux';

import jobs from './jobs/reducer';
import job from './job/reducer';
import search from './search/reducer';



export default combineReducers({
  
  job,
  jobs, 
  search,
 
});
